import React from 'react';
// import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import ProductForm from '../ProductForm/productForm';
import { Wrapper, Header } from './addProduct.style';
import 'antd/dist/antd.css';


const AddProduct = ({ open, product, handleClose, clearProductData, handleAddProduct }) => {

  return (
    <Dialog open={open} onClose={handleClose} fullScreen fullWidth>
      <Wrapper>
        <Header>
          <Typography component="h3" className="title">
            Add a Product
          </Typography>
         <div>
          <Button variant="contained" onClick={clearProductData} style={{margin: "0 4px"}}>
           Clear
          </Button>
          <Button variant="contained" onClick={handleClose} style={{margin: "0 4px"}}>
           Close
          </Button>
         </div>
        </Header>
        <ProductForm product={product} handleAddProduct={handleAddProduct} />
      </Wrapper>
    </Dialog>
  );
};

export default AddProduct;
